var initialState = {
    weather: 0,
    HomeTeam: {
      Id: 1,
      Name: 'Манчестер Юнайтед',
      Flag: '',
      Back: 'yellow',
      Color:'black',
      Players:[
      ],
      Formation: [
        1,2,3,5,6,9,10,11,12,23,24
      ]
    },
    AwayTeam: {
      Id: 2,
      Name: 'Ливерпуль',
      Flag: '',
      Back: 'black',
      Color:'white',
      Players:[
      ],
      Formation: [
        1,2,3,5,6,9,10,11,12,22,24
      ]
    },
    Stats: {
      Score: {
          Home: 0,
          Away: 0
      },
      Shots: {
          Home: 0,
          Away: 0
      },
      ShotsOnGoal: {
        Home: 0,
        Away: 0
      },
      XG: {
        Home: 0,
        Away: 0
      },
      BlockedShots: {
        Home: 0,
        Away: 0
      },
      Corners: {
          Home: 0,
          Away: 0
      },
      Fouls: {
          Home: 0,
          Away: 0
      },
      FreeKicks: {
          Home: 0,
          Away: 0
      },
      Penalty: {
          Home: 0,
          Away: 0
      },
      Offsides: {
          Home: 0,
          Away: 0
      },
      Possession: {
        Home: 50,
        Away: 50
      },
      EventList: []
    },
    online_games : {
      minute: 0,
      games: []
    },
    theme: 0,
    currentEvent: 0,
    gameSpeed: 20,
    jsonLoaded: false,
    paused: true,
    show3d: false,
    muted: false,
    showSettings: false,
    showAbout: false,
    showDonate: false,
    statisticWindows: {
        statsSelectorVisible: false,
        summary: {
          visible: false,
          is_cut_down: false
        },
        latestScores: {
          visible: false,
          is_cut_down: false
        },
        homePlayersStats: {
          visible: false,
          is_cut_down: false
        },
        awayPlayersStats: {
          visible: false,
          is_cut_down: false
        }
        ,
        homeFormation: {
          visible: false,
          is_cut_down: false
        },
        awayFormation: {
          visible: false,
          is_cut_down: false
        },
        gameStats: {
          visible: false,
          is_cut_down: false
        },
        text: {
          visible: false,
          is_cut_down: false,
          height: 300,
          width: 400
        },
        pitch: {
          visible: false,
          is_cut_down: false,
          height: 550,
          width: 820
        },
        chat: {
          visible: false,
          is_cut_down: false
        }
    },
    chat: {
      userName: '',
      connected: false,
      channels: [],
      selectedChannelId: null,
      messages: []
    },
    timeAdded: null,
    sidesSwap: 0
};

export function GetInitialState() {
    return JSON.parse( JSON.stringify( initialState ) );
}


/** WEBPACK FOOTER **
 ** ./src/reducers/initialState.js
 **/